// extracted by mini-css-extract-plugin
module.exports = {"headerMargin":"style_headerMargin__11Tm-","mainContent":"style_mainContent__114Hq","main":"style_main__26shb","page":"style_page__3IhFl","mobileTopBar":"style_mobileTopBar__sAkV6"};